<!--
  @Description: 购票
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div class="main-container">
    <page-header>{{'获取门票' | dealLanguage('Get tickets')}}</page-header>
    <div class="center-wrapper">
      <div class="top-tip">
        您好，感谢您关注<span>{{activityDetail.name}}</span>！<br />
        本届展会采用展前“线上预约登记”及现场核验“参会凭证”形式，请务必携带电子参会凭证或打印版参会凭证参会。<br />
        如有任何问题，敬请电话咨询：<span>13372677093 王先生</span>。
      </div>
      <div class="form-view">
        <Form ref="current-form" :model="currentForm" :rules="ruleValidate2">
          <div class="view-title">
            <div class="title">{{'身份信息' | dealLanguage('Identity Imfomation')}}</div>
            <div class="line"></div>
            <!-- <div class="companions">
              <Checkbox v-model="partnerSingle" @on-change="handleChangeSingle">{{'帮他人获取门票' | dealLanguage('Get Tickets for Others')}}</Checkbox>
              <Select v-model="currentPartnerId" size="small" style="width:140px" :placeholder="'请选择同行人' | dealLanguage('Please select')" v-if="partnerSingle" @on-change="handleChangePartner">
                <Option v-for="item in partnerList" :value="item.id" :key="item">{{ item.name }}</Option>
              </Select>
            </div> -->
          </div>
          <Row :gutter="26" v-if="partnerSingle">
            <Col span="6">
            <FormItem prop="mobileAreaCode" :label="'国家地区码' | dealLanguage('Area Code')">
              <Select v-model="currentForm.mobileAreaCode" :disabled="currentPartnerId" :placeholder="'请选择国家/地区码' | dealLanguage('Please select a country/region code')">
                <Option v-for="item in appMobileAreaCodeDtos" :value="item.mobileAreaCode" :key="item.mobileAreaCode">+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="10">
            <FormItem prop="mobile" :label="'手机号码' | dealLanguage('Phone Number')">
              <Input type="text" :disabled="currentPartnerId" v-model="currentForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
            </FormItem>
            </Col>
            <Col span="8" v-if="!currentPartnerId">
            <FormItem prop="mobileVerifyCode" :label="'验证码' | dealLanguage('Phone Code')">
              <Input type="text" class="right-padding" v-model="currentForm.mobileVerifyCode" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')"></Input>
              <Captcha ref="captcha" scene="vbdata_bidingmobile" :mobile="currentForm.mobile" :mobileAreaCode="currentForm.mobileAreaCode"></Captcha>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
            <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
          </FormItem>
          <FormItem prop="compName" :label="'公司' | dealLanguage('Company Name')">
            <div class="input-tag">
              <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                <Option v-for="item in entityList" :value="item.id" :key="item.id">
                  <div class="title">
                    {{item.shortName}}
                  </div>
                  <div class="desc">
                    {{item.description}}
                  </div>
                </Option>
              </AutoComplete>
              <div class="tag-div" v-if="currentForm.entityId">
                <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
              </div>
            </div>
          </FormItem>
          <Row :gutter="26">
            <Col span="12">
            <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
              <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门' | dealLanguage('Please fill in the department')"></Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
              <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="26">
            <Col span="12">
            <FormItem prop="companyNatureId" :label="'请问贵公司性质' | dealLanguage('Type of Company')">
              <treeselect v-model="currentForm.companyNatureId" :disableBranchNodes="true" :placeholder="'请选择' | dealLanguage('Please select')" :options="companyNatureTree" @input="handleChangeNT($event, 0)" v-if="companyNatureTree.length" />
            </FormItem>
            </Col>
            <Col span="12" v-if="compNTother">
            <FormItem prop="companyNatureOtherTagName" :label="'其他' | dealLanguage('Other')">
              <Input type="text" v-model="currentForm.companyNatureOtherTagName" :placeholder="'请填写具体性质' | dealLanguage('Please fill in the specific nature')"></Input>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="forums" :label="'您需要参加同期的以下哪些会议及活动（多选）' | dealLanguage('Which of the following conferences and events do you need to attend during the same period？(multi-select)')">
            <CheckboxGroup v-model="currentForm.forums">
              <Checkbox :label="item" v-for="item,index in forums" :key="index"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <div class="view-title">
            <div class="title"><span class="red">*</span>{{'您参加本次大会最想实现的需求是（请选出最重要的3项）' | dealLanguage('What is your most desired requirement for attending this conference?(Please select the three most important items)')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="need">
            <CheckboxGroup v-model="currentForm.need" @on-change="handleChangeNeed">
              <Checkbox :label="item" v-for="item,index in needList" :key="index"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem prop="needother" v-if="needother">
            <Input type="text" v-model="currentForm.needother" :placeholder="'请填写具体需求' | dealLanguage('Please fill in the specific requirements')"></Input>
          </FormItem>
          <div class="view-title">
            <div class="title"><span class="red">*</span>{{'您是否需要商贸对接服务？' | dealLanguage('Do you need business matching services?')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="service">
            <RadioGroup v-model="currentForm.service" @on-change="handleChangeService">
              <Radio :label="item" v-for="item,index in serviceList" :key="index"></Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="serviceother" v-if="serviceother">
            <Input type="text" v-model="currentForm.serviceother" :placeholder="'请填写具体服务内容' | dealLanguage('Please fill in the specific service content')"></Input>
          </FormItem>
          <div class="view-title">
            <div class="title">{{'请选择门票类型' | dealLanguage('Please select the ticket type')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="activityTicketId">
            <div class="ticket-list">
              <RadioGroup v-model="currentForm.activityTicketId" @on-change="handleSeletTicket">
                <Radio :label="item.id" v-for="item,index in ticketList" :key="index">
                  <div class="ticket-item ticket-container">
                    <div class="ticket-item-top">
                      <div class="ticket-item-top-left">
                        <img :src="item.activityShareImagePath | logo_show" />
                        <!-- <img :src="item.activityLogoPath | logo_show" /> -->
                      </div>
                      <div class="ticket-item-top-right">
                        <div>
                          <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
                          <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                          <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                        </div>
                        <div class="price" v-if="item.price">￥{{item.price | amount_show}}</div>
                        <div class="price" v-else>{{'免费' | dealLanguage('FREE')}}</div>
                      </div>
                    </div>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
          </FormItem>
        </Form>
        <div class="view-title">
          <div class="title">{{'支付信息' | dealLanguage('Payment imformation')}}</div>
          <div class="line"></div>
        </div>
        <div class="pay-info">
          <div class="pay-type">
            <div class="pay-type-btn">
              <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
              <span>{{'微信支付' | dealLanguage('WeChat Pay')}}</span>
            </div>
          </div>
          <div class="info" v-if="this.currentTicket.id">
            <div class="info-p1">{{'门票价格：' | dealLanguage('Ticket price')}}<span>￥{{this.currentTicket.price | amount_show}}</span></div>
            <div class="info-p2" v-if="this.currentTicket.price">{{'您需支付' | dealLanguage('You need to pay ')}}￥{{this.currentTicket.price | amount_show}}{{'用以支付当前门票' | dealLanguage(' to pay for the current ticket')}}</div>
            <div class="info-p2" v-else>{{'您不需要支付' | dealLanguage("You don't have to pay")}}</div>
          </div>
        </div>
        <div class="btn-wrapper">
          <Button type="primary" @click="submit" :loading="buttonLoading">
            <span v-if="buttonLoading">{{'提交中' | dealLanguage('Loading')}}</span>
            <span v-else>{{'获取门票' | dealLanguage('Get ticket now')}}</span>
          </Button>
        </div>
      </div>
    </div>
    <Modal v-model="payShow" width="530" class="login-model" :mask-closable="false" :footer-hide="true" :transfer="false" @on-visible-change="handleListenOrder">
      <div class="container-wrapper">
        <img :src="static_img_url + 'pic/modal-bg2.png?v=' + $store.state.imgVersion" class="model-bg" />
        <div class="container-content">
          <div class="container-top">
            <div class="container-title reset-form-title">{{'支付订单-微信支付' | dealLanguage('WeChat Pay')}}</div>
            <div class="preview-pic">
              <img :src="payCodePath" class="code-img" />
              <div class="p0">{{'支付金额：' | dealLanguage('Amount')}}<span>￥{{this.currentTicket.price | amount_show}}</span></div>
              <div class="p1">
                <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
                <span>{{'请使用微信扫码支付' | dealLanguage('Please use WeChat to scan the QR code to pay')}}</span>
              </div>
              <div class="p2">
                {{'支付过程中，请勿关闭此窗口' | dealLanguage('Please do not close this window during the payment process.')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { Auserinfo } from '@/service/app'
import { vbefGenOrder, orderStatus, getPartnerList } from '@/service/vbef'
import { searchEntity } from 'js/searchEntity'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import QRCode from 'qrcode'
import { loginCommon } from '@/assets/js/login'
import { signUpMixins } from '@/assets/js/signUpMixins'

import filter from 'js/filter'
import Captcha from '@/components/common/captcha'

export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('获取门票', 'Get tickets'),
    }
  },
  inject: ['login'],
  mixins: [searchEntity, loginCommon, signUpMixins],
  components: {
    PageHeader,
    Treeselect,
    Captcha,
  },
  created() {
    this.Agetmeta()
    this.getTicketList()
    // this.getPartnerList()
  },
  mounted() {
    if (!this.user_key) {
      this.login(this.ininUserInfo)
    } else {
      this.ininUserInfo()
    }
  },
  beforeDestroy() {
    clearInterval(this.orderInv)
  },
  data() {
    return {
      filter,
      buttonLoading: false,
      payCodePath: '',
      payShow: false,
      orderInv: 0,
      payOrderId: '',
    }
  },
  
  methods: {
    ininUserInfo() {
      if (this.partnerSingle) {
        this.currentForm.name = ''
        this.currentForm.compName = ''
        this.entityKeyword = ''
        this.currentForm.entityId = 0
        this.currentForm.department = ''
        this.currentForm.title = ''
        this.currentForm.companyNatureId = null
        this.currentForm.companyNatureOtherTagName = ''
        this.currentForm.mobile = ''
        this.currentForm.mobileAreaCode = '86'
        this.currentForm.mobileVerifyCode = ''
        return
      }
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = ''
      this.currentForm.mobileAreaCode = '86'
      this.currentForm.mobileVerifyCode = ''
    },
    /**
     * 提交表单
     */
    submit() {
      if (this.buttonLoading) return
      if (!this.user_key) {
        this.login()
        return
      }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let partnerInfo = null,
            ownXuserid = 0
          if (!this.partnerSingle) {
            let userParams = {
              name: this.currentForm.name,
              compName: this.currentForm.compName,
              entityId: this.currentForm.entityId,
              department: this.currentForm.department,
              title: this.currentForm.title,
              companyNatureId: this.currentForm.companyNatureId,
              companyNatureOtherTagName: this.currentForm.companyNatureOtherTagName,
            }
            let res = await Auserinfo(userParams)
            if (res.code == 0) {
              let user = { ...this.user }
              user.name = this.currentForm.name
              user.compName = this.currentForm.compName
              user.entityId = this.currentForm.entityId
              user.department = this.currentForm.department
              user.title = this.currentForm.title
              user.companyNatureId = this.currentForm.companyNatureId
              user.companyNatureOtherTagName = this.currentForm.companyNatureOtherTagName
              this.$store.commit('updateUser', user)
            }
          } else {
            ownXuserid = this.currentPartner.xuserid //同行人
            partnerInfo = {
              name: this.currentForm.name,
              compName: this.currentForm.compName,
              entityId: this.currentForm.entityId,
              department: this.currentForm.department,
              title: this.currentForm.title,
              companyNatureId: this.currentForm.companyNatureId,
              companyNatureOtherTagName: this.currentForm.companyNatureOtherTagName,
              mobile: this.currentForm.mobile,
              mobileAreaCode: this.currentForm.mobileAreaCode,
              mobileVerifyCode: this.currentForm.mobileVerifyCode,
            }
          }

          let { activityTicketId, ...params } = this.currentForm

          let ticketParamsStr = JSON.stringify(params)
          let pay_type = this.currentTicket.type == 1 ? 0 : 3
          let order = await vbefGenOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            loginPlatform: 6,
            payType: pay_type,
            ownXuserid,
            partnerInfo,
          })
          this.buttonLoading = false
          if (order.code == 0) {
            if (order.data.payType == 0) {
              this.$Message.success(
                this.language == 'zh' ? '报名成功！' : 'Registration successful!'
              )
              if (this.partnerSingle) {
                this.$router.push({
                  name: 'myTickets',
                })
                return
              }
              this.$router.push({
                name: 'ticketDetail',
                params: { id: order.data.activityTicketUserRelationId },
              })
              return
            }
            QRCode.toDataURL(order.data.wxPayMpOrderNativeCodeUrl, {
              margin: 1,
              height: 320,
              width: 320,
            }).then((url) => {
              this.payOrderId = order.data.activityOrderId
              this.payShow = true
              this.payCodePath = url
            })
          } else {
            this.$Message.error(filter.dealLanguage(order.msg, order.enMsg || order.msg))
          }
        } else {
          this.$Message.error(
            this.language == 'zh' ? '请完善表单后提交' : 'Please complete the form and submit it'
          )
        }
      })
    },
    async orderStatus(orderId) {
      let res = await orderStatus({
        id: this.payOrderId,
      })
      if (res.code == 0) {
        if (res.data.status == 2) {
          this.$Message.success(this.language == 'zh' ? '购买成功！' : 'Purchase successful!')
          clearInterval(this.orderInv)
          if (this.partnerSingle) {
            this.$router.push({
              name: 'myTickets',
            })
            return
          }
          this.$router.push({
            name: 'ticketDetail',
            params: { id: res.data.activityTicketUserRelationId },
          })
        }
      }
    },
    handleListenOrder(value) {
      if (value) {
        this.orderInv = setInterval(() => {
          this.orderStatus()
        }, 1000)
      } else {
        clearInterval(this.orderInv)
      }
    },
  },
  watch: {
    needother() {
      this.currentForm.needother = ''
    },
    serviceother() {
      this.currentForm.serviceother = ''
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
@import '~styles/ticket-item.styl'
@import '~styles/login.styl'
.form-view
  .companions
    height 30px
    margin-left 10px
    display flex
    align-items center
    >>> .ivu-checkbox-wrapper
      white-space nowrap
      color #1890ff
    >>> .ivu-select
      .ivu-select-selection
        height 28px
        .ivu-select-placeholder, .ivu-select-selected-value
          padding-left 10px
          height 26px
          line-height 26px
.center-wrapper
  padding 20px 0 30px
  .top-tip
    font-size 16px
    color #3D3D3D
    line-height 28px
    text-align justify
    span
      color #FA5A00
  .btn-wrapper
    margin-top 35px
    text-align right
  .ticket-list
    .ticket-item-top
      height 100%
    >>> .ivu-radio-group
      display flex
      flex-wrap wrap
      .ivu-radio-wrapper
        flex 0 0 390px
        max-width 390px
        min-width 390px
        margin 0
        &:not(:nth-of-type(2n+1))
          margin-left 20px
        &:nth-of-type(n+3)
          margin-top 20px
      .ivu-radio
        position absolute
        margin-right 0
        z-index 2
        right 16px
        top 16px
      .ticket-item-top-right .title
        padding-right 20px
      .ivu-radio-wrapper-checked
        .ivu-radio-inner
          border-color #FA5A00
        .ticket-container
          border-color #FA5A00
          &::before, &::after
            background-image url('~pic/ticket-bg-pc-active.png')
      .ivu-radio-focus
        box-shadow 0 0 2px rgba(255, 136, 36, 0.4)
      .ivu-radio-inner
        border-color #ffe6d1
        &:after
          background-color #FA5A00
      span.ivu-radio+*
        margin 0
.preview-pic
  padding-top 60px
  .code-img
    height 140px
    width 140px
    display block
    margin 0 auto
  .p0
    font-size 18px
    color #333333
    line-height 25px
    text-align center
    margin 13px auto 0
    span
      color #ED4014
  .p1
    font-size 14px
    color #666666
    line-height 20px
    text-align center
    margin 42px auto 0
    img
      width 14px
      height 14px
      margin-right 5px
      vertical-align middle
      display inline-block
  .p2
    font-size 14px
    color #999999
    line-height 20px
    text-align center
    margin 10px auto 0
.pay-info
  display flex
  justify-content space-between
  align-items center
  margin-top 20px
  .pay-type-btn
    display flex
    align-items center
    width 120px
    justify-content center
    height 30px
    box-shadow 0px 1px 3px rgba(25, 26, 47, 0.3)
    border-radius 4px
    img
      width 20px
      height 20px
    span
      font-size 15px
      color #3D3D3D
      line-height 20px
      margin-left 6px
  .info
    text-align right
    .info-p1
      font-size 26px
      color #333333
      line-height 36px
      span
        color #ED4014
    .info-p2
      margin-top 10px
      font-size 14px
      color #666666
      line-height 20px
</style>